/*
 *
 * Contacts reducer
 *
 */
const initialState = {
  imports: [],
  contacts: [],
  contactsCount: null,
  contactsModal: [],
  contactsCountModal: null,
  haveContacts: false,
  contactsPage: 0,
  columnSize: [],
  typeContacts: "",
  typeCampaigns: "",
  isModalVisible: false,
};

const contacts = (state = initialState, action) => {
  switch (action.type) {
    case "ALL_CONTACTS":
      return Object.assign({}, state, {
        contacts: action.payload.contacts,
      });
    case "IS_MODAL_VISIBLE":
      return Object.assign({}, state, {
        isModalVisible: action.payload.isModalVisible,
      });
    case "CONTACTS_COUNT":
      return Object.assign({}, state, {
        contactsCount: action.payload.contactsCount,
      });
    case "ALL_CONTACTS_MODAL":
      return Object.assign({}, state, {
        contactsModal: action.payload.contactsModal,
      });

    case "CONTACTS_PAGE":
      return Object.assign({}, state, {
        contactsPage: action.payload.contactsPage,
      });

    case "COLUMN_SIZE":
      return Object.assign({}, state, {
        columnSize: action.payload.columnSize,
      });
    case "TYPE_CONTACTS":
      return Object.assign({}, state, {
        typeContacts: action.payload.typeContacts,
      });
    case "TYPE_CAMPAIGNS":
      return Object.assign({}, state, {
        typeCampaigns: action.payload.typeCampaigns,
      });
    case "RECENT_IMPORTS":
      return Object.assign({}, state, {
        imports: action.payload.imports,
      });
    case "HAVE_CONTACTS":
      return Object.assign({}, state, {
        haveContacts: action.payload.haveContacts,
      });
    case "UPDATE_IMPORTED_CONTACT":
      return Object.assign({}, state, {
        imports: action.payload.imports,
      });
    default:
      return state;
  }
};

export default contacts;
